import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AgmCoreModule } from "@agm/core";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { PractitionerComponent } from './practitioner/practitioner.component';
import { PractitionerCreateComponent } from './practitioner/practitioner-create/practitioner-create.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PractitionerListComponent } from './practitioner/practitioner-list/practitioner-list.component';
import { PractitionerService } from './shared/services/practitioner.service';
import { environment } from 'src/environments/environment';
import { PractitionerTestimonialComponent } from './practitioner/practitioner-testimonial/practitioner-testimonial.component';
import { GooglePlacesComponent } from './shared/components/google-places/google-places.component';
import { SearchComponent } from './search/search.component';
import { HomeComponent } from './home/home.component';
import { SearchBarComponent } from './search/search-bar/search-bar.component';
import { MailService } from './shared/services/mail.service';
import { PractitionerDetailComponent } from './practitioner/practitioner-detail/practitioner-detail.component';
import { PractitionerListItemComponent } from './practitioner/practitioner-list/practitioner-list-item/practitioner-list-item.component';
import { StarRatingsComponent } from './shared/components/star-ratings/star-ratings.component';
import { LoginComponent } from './login/login.component';
import { AuthService } from './shared/services/auth.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { RatingSelectorComponent } from './shared/components/rating-selector/rating-selector.component';
import { TestimonialService } from './shared/services/testimonial.service';
import { LookupService } from './shared/services/lookup.service';
import { LookupTypeaheadComponent } from './shared/components/lookup-typeahead/lookup-typeahead.component';
import { ToastService } from './shared/services/toast.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import { BookingFormComponent } from './shared/components/booking-form/booking-form.component';
import { BookingService } from './shared/services/booking.service';
import { ModalNotificationComponent } from './shared/components/modal-notification/modal-notification.component';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { SizeMatchDirective } from './shared/directives/sizeMatch.directive';
import { PractitionerRegisterComponent } from './practitioner/practitioner-register/practitioner-register.component';
import { RegisterGuard } from './shared/guards/register.guard';
import { AdminComponent } from './admin/admin.component';
import { AdminPractitionerListComponent } from './admin/admin-practitioner-list/admin-practitioner-list.component';
import { AdminSearchComponent } from './admin/admin-search/admin-search.component';
import { StatusService } from './shared/services/status.service';
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { AdminPractitionerItemComponent } from './admin/admin-practitioner-list/admin-practitioner-item/admin-practitioner-item.component';
import { AdminGuard } from './shared/guards/admin.guard';
import { PractitionerEditComponent } from './practitioner/practitioner-edit/practitioner-edit.component';
import { PractitionerEditPersonalComponent } from './practitioner/practitioner-edit/practitioner-edit-personal/practitioner-edit-personal.component';
import { StatusBannerComponent } from './shared/components/status-banner/status-banner.component';
import { PractitionerEditConditionsComponent } from './practitioner/practitioner-edit/practitioner-edit-conditions/practitioner-edit-conditions.component';
import { PractitionerEditServicesComponent } from './practitioner/practitioner-edit/practitioner-edit-services/practitioner-edit-services.component';
import { PractitionerEditBusinessComponent } from './practitioner/practitioner-edit/practitioner-edit-business/practitioner-edit-business.component';
import { PractitionerEditExperienceComponent } from './practitioner/practitioner-edit/practitioner-edit-experience/practitioner-edit-experience.component';
import { PractitionerEditBioComponent } from './practitioner/practitioner-edit/practitioner-edit-bio/practitioner-edit-bio.component';
import { PractitionerEditPhotoComponent } from './practitioner/practitioner-edit/practitioner-edit-photo/practitioner-edit-photo.component';
import { AboutComponent } from './about/about.component';
import { PractitionerBookingsComponent } from './practitioner/practitioner-bookings/practitioner-bookings.component';
import { PractitionerBookingItemComponent } from './practitioner/practitioner-bookings/practitioner-booking-item/practitioner-booking-item.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PractitionerComponent,
    PractitionerCreateComponent,
    PractitionerDetailComponent,
    PractitionerListComponent,
    PractitionerTestimonialComponent,
    GooglePlacesComponent,
    SearchComponent,
    HomeComponent,
    SearchBarComponent,
    PractitionerListItemComponent,
    StarRatingsComponent,
    LoginComponent,
    LoaderComponent,
    RatingSelectorComponent,
    LookupTypeaheadComponent,
    ToastComponent,
    BookingFormComponent,
    ModalNotificationComponent,
    SizeMatchDirective,
    PractitionerRegisterComponent,
    AdminComponent,
    AdminPractitionerListComponent,
    AdminSearchComponent,
    AdminLoginComponent,
    AdminPractitionerItemComponent,
    PractitionerEditComponent,
    PractitionerEditPersonalComponent,
    StatusBannerComponent,
    PractitionerEditConditionsComponent,
    PractitionerEditServicesComponent,
    PractitionerEditBusinessComponent,
    PractitionerEditExperienceComponent,
    PractitionerEditBioComponent,
    PractitionerEditPhotoComponent,
    AboutComponent,
    PractitionerBookingsComponent,
    PractitionerBookingItemComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDalaHXUUcPiyZ9q6aD1Nc_xbuuApzaUBQ',
      libraries: ['places']
    }),
    NgbModule,
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot(environment.firebaseConfig.measurementId),
    NgxGoogleAnalyticsRouterModule
  ],
  providers: [
    PractitionerService,
    MailService,
    AuthService,
    AuthGuard,
    RegisterGuard,
    AdminGuard,
    TestimonialService,
    LookupService,
    ToastService,
    BookingService,
    StatusService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
